interface QuestionnaireActionsProps {
  onBack: () => void;
  continueLabel?: string;
  isLoading?: boolean;
  isFirstStep?: boolean;
}

export function QuestionnaireActions({
  onBack,
  continueLabel = "Continuar",
  isLoading = false,
  isFirstStep = false,
}: QuestionnaireActionsProps) {
  return (
    <div className="questionnaire-actions">
      <button
        className="questionnaire-button questionnaire-button--back"
        type="button"
        onClick={onBack}
        disabled={isLoading}
      >
        <span aria-hidden="true">←</span>
        {isFirstStep ? "Volver al inicio" : "Atrás"}
      </button>
      <button
        className="questionnaire-button questionnaire-button--primary"
        type="submit"
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <span className="questionnaire-spinner" aria-hidden="true" />
            Enviando…
          </>
        ) : (
          <>
            {continueLabel}
            <span aria-hidden="true">→</span>
          </>
        )}
      </button>
    </div>
  );
}

